<!--
 * @Description: 订单统计页面
 * @Author: gaohc
 * @Date: 2022-05-30 16:43:52
-->
<template>
  <div class="body">
    <div v-loading="loading" element-loading-text="正在导出...">
      <el-row style="margin: 25px 40px">
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 70px;">机构：</span>
          <el-select v-model="filterParams.institutionId" clearable filterable size="small"
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
				  		srcInstitutionList, this))"
            @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
				  		'institutionList', srcInstitutionList, this)"
            placeholder="拼音/首字母" style="width: 220px" @change="handelChangeInst">
            <el-option v-for="item in institutionList" :key="item.id"
              :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 98px;">医院：</span>
          <el-select v-model="filterParams.hospitalId" filterable clearable size="small"
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
			  			'hospitalList', srcHospitalList, this))"
            @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
			  			visible, 'hospitalList', srcHospitalList, this)"
            placeholder="请选择" style="width: 220px" @change="getDepList">
            <el-option v-for="item in hospitalList" :key="item.id"
              :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5" style="text-align: center">
          <span class="search-title" style="width: 56px;">科室：</span>
          <el-cascader size="small" style="width: 130px"
            v-model="deptFilterList" clearable filterable :disabled="deptDisabled"
            placeholder="请选择" :options="deptList" :props="{checkStrictly: true,
			  		expandTrigger: 'hover', children: 'childList', label: 'name', value: 'id'}">
          </el-cascader>
        </el-col>
        <el-col :span="5" style="text-align: right">
          <span class="search-title">支付方式：</span>
          <el-select v-model="filterParams.payWay" size="small" filterable
            clearable placeholder="请选择" style="width: 130px">
            <el-option v-for="(item, index) in payWayTypeList" :key="index"
              :label="item.value" :value="item.key * 1">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin: 0 40px 25px 40px; text-align: left">
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 70px;">状态：</span>
          <el-select v-model="filterParams.status" filterable clearable
            size="small" placeholder="请选择" style="width: 220px">
            <el-option v-for="(item, index) in orderStatusList" :key="index"
              :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 98px;">派单人：</span>
          <el-input v-model="filterParams.distributorNameTeleno" size="small"
            clearable style="width: 220px" placeholder="姓名/手机号">
			  	</el-input>
        </el-col>
        <el-col :span="5" style="text-align: center">
          <span class="search-title" style="width: 56px;">服务人：</span>
          <el-input v-model="filterParams.serviceNameTeleno" size="small"
            clearable style="width: 130px" placeholder="姓名/手机号">
			  	</el-input>
        </el-col>
        <el-col :span="5" style="text-align: right">
          <span class="search-title">服务名称：</span>
          <el-input v-model="filterParams.hserviceName" size="small"
            clearable style="width: 130px" placeholder="服务名称">
			  	</el-input>
        </el-col>
      </el-row>
      <el-row class="search-row2-margin">
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 70px;">下单时间：</span>
          <el-date-picker v-model="orderDateRange" style="width: 220px" type="datetimerange"
            align="right" unlink-panels range-separator="至" size="small"
            :default-time="['00:00:00', '23:59:59']" start-placeholder="开始时间"
            end-placeholder="结束时间" :picker-options="dateRangePickerOptions">
          </el-date-picker>
        </el-col>
        <el-col :span="7" style="text-align: left">
          <span class="search-title" style="width: 98px;">完成分账时间：</span>
          <el-date-picker v-model="completeSharingDateRange" style="width: 220px" type="datetimerange"
            align="right" unlink-panels range-separator="至" size="small"
            :default-time="['00:00:00', '23:59:59']" start-placeholder="开始时间"
            end-placeholder="结束时间" :picker-options="dateRangePickerOptions">
          </el-date-picker>
        </el-col>
        <el-col :span="10" style="text-align: right">
          <el-button size="small" style="height: 32.59px" @click="handleExportOrderListExcel" 
            v-if="dataPvgList.includes('ORDER_1_EXPORT')" 
            type="primary" icon="el-icon-export-excel">
			  		导 出
			  	</el-button>
          <el-button size="small" @click="queryData" type="primary" icon="el-icon-search">
			  		搜 索
			  	</el-button>
        </el-col>
      </el-row>
      <div class="main-line"></div>
      <el-row style="margin: 25px 40px; height: 40px; line-height: 40px">
        <el-col :span="9" style="font-size: 14px; color: #323333; text-align: left">
          <img style="width: 14px; height: 12px" alt=""
            src="../../assets/report/icon-report-order-chart.png"/>
          <span>订单统计分析</span>
          <span v-if="0">
			  		{{ "(" + startDate + " 至 " }}{{ endDate + ")" }}
			  	</span>
        </el-col>
        <el-col :span="15" style="text-align: right">
          <span style="font-size: 14px; color: #333333">
			  		订单总金额:
			  	</span>
          <span style="font-size: 14px; color: #3e7ef5">
			  		{{ totalAmount }}
			  	</span>
          <span style="font-size: 14px; color: #333333; margin-left: 30px">
			  		订单实付款总金额:
			  	</span>
          <span style="font-size: 14px; color: #3e7ef5">
			  		{{ payAmount }}
			  	</span>
          <span style="font-size: 14px; color: #333333; margin-left: 30px">
			  		订单总数量:
			  	</span>
          <span style="font-size: 14px; color: #3e7ef5">
			  		{{ totalQuantity + '单'}}
			  	</span>
        </el-col>
      </el-row>
      <div class="report-echat">
        <div id="concurrents-area" style="height: 100%; width: 100%"></div>
      </div>
      <div class="main-line" style="margin: 25px 0"></div>
    </div>

    <el-table style="margin: 0 44px; border: 1px solid #f0f0f0" :style="tableWidth"
      :data="dataTable" :header-cell-style="{'text-align': 'left', 'background-color': '#EFF5FA'}">
      <el-table-column label="订单编号" min-width="11%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">
            <el-tooltip :content="scope.row.delegateOrderText" placement="top" 
              v-if="scope.row.isDelegateOrder">
					    <span class="replace-order">代</span>
					  </el-tooltip>
            <span class="repeat-order" v-if="scope.row.repurchase">复</span>
            <el-popover placement="bottom" width="181" trigger="hover">
              <span slot="reference">{{scope.row.no ? scope.row.no : '- -'}}</span>
              <div style="display: flex; align-items: flex-end; justify-content: space-between;">
                <span>{{ scope.row.no }}</span>
                <img style="width: 16px; height: 16px; cursor: pointer;" 
                  @click="copyText(scope.row.no)"
                  src="@/assets/ordermng/icon-ordermng-copy.png" alt="">  
              </div>
            </el-popover>
          </span>
        </template>
			</el-table-column>
      <el-table-column prop="genTime" label="下单时间" sortable min-width="10%" align="left">
      </el-table-column>
      <el-table-column prop="serviceName" label="服务名称" min-width="11%" align="left">
        <template slot-scope="scope">
          <el-popover placement="bottom" width="181" trigger="hover">
            <span slot="reference" class="overflow-text-style">
              {{scope.row.serviceName}}
            </span>
            <div style="display: flex; align-items: flex-end; justify-content: space-between;">
              <span>{{ scope.row.serviceName }}</span>
              <img style="width: 16px; height: 16px; cursor: pointer;" 
                @click="copyText(scope.row.serviceName)"
                src="@/assets/ordermng/icon-ordermng-copy.png" alt="">  
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="被服务人" min-width="9%" align="left">
        <template slot-scope="scope">
          {{ scope.row.servdePersonName }}
          <div>{{ scope.row.servdePersonMobile }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单金额" :sortable="true" prop="totalAmountYuan"
        :sort-method="sortMethod" min-width="12%" align="left">
        <template slot-scope="scope">
          ￥{{ scope.row.totalAmountYuan ? scope.row.totalAmountYuan : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="服务机构" min-width="10%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">{{ scope.row.institutionName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属医院" min-width="11%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">{{ scope.row.hospitalName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属科室" min-width="11%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">
            {{ scope.row.department1Name ? scope.row.department1Name :'- -' }}
            <span v-if="scope.row.department2Name">/{{ scope.row.department2Name }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" min-width="8%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style"> 
            {{ scope.row.payWayText ? scope.row.payWayText : "- -" }}
          </span> 
        </template>
      </el-table-column>
      <el-table-column label="订单状态" min-width="8%" align="left">
        <template slot-scope="scope">
          {{ scope.row.statusText }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="8%" align="left">
        <template slot-scope="scope">
          <el-tooltip content="详情" placement="top">
						<img style="width: 17px; height: 18px; vertical-align: top; cursor: pointer;"
							@click="handleDetailClick(scope.row)" 
              src="@/assets/common/icon-common-detail.png" alt="">
					</el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
    </el-row>

		<!-- 查看订单详情 -->
    <order-details-dialog :visible="showOrderDialog" @check-collectdetails="handleSeeCollectDetails"
      @close-dialog="closeOrderDialog" :orderId="orderId">
		</order-details-dialog>

		<!-- 查看支退记录 -->
    <payment-details-dialog :visible="showCollectMoneyDialog" @close-dialog="closeDialog"
      :orderId="orderId" />

    <!-- 导出邮箱提示订弹框 -->
    <export-email-tip-dialog :visible="showExportEmailTipDialog" :exportParam="exportParam"
      :email="email" @close-dialog="closeExportEmailTipDialog"/>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";
import OrderDetails from "../ordermng/components/OrderDetails.vue";
import PaymentDetails from "../ordermng/components/PaymentDetails.vue";
import ExportEmailTipDlg from "./components/ExportEmailTipDlg.vue"

export default {
  name: "OrderReport",
  components: {
    "order-details-dialog": OrderDetails,
    "payment-details-dialog": PaymentDetails,
    "export-email-tip-dialog": ExportEmailTipDlg,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        institutionId: null,
        hospitalId: null,
        serviceNameTeleno: null,
        status: null,
        distributorNameTeleno: null,
        hserviceName: null,
        begDate: null,
        endDate: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      loading: false,

      institutionList: null,
      srcInstitutionList: [],
      hospitalList: [],
      srcHospitalList: [],
      orderStatusList: [],
      payWayTypeList: [],
      dataTable: [],

      orderDateRange: null,
      completeSharingDateRange: null,
      dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(
        true,
        false
      ),

      xAxisData: null,
      amountChartMap: null,
      quantityChartMap: null,
      payAmountChartMap: null,
      endDate: "",
      startDate: "",
      totalAmount: "",
      totalQuantity: "",
      payAmount: "",

      //订单详情dialog变量
      orderId: null,
      showOrderDialog: false,

      //评估收款详情dialog变量
      showCollectMoneyDialog: false,

      //导出邮箱提示订弹框变量
      showExportEmailTipDialog: false,
      exportParam: {},
      email: '',

      deptDisabled: true,
      deptList: [],
      deptFilterList: []
    };
  },

  computed: {
    buildOrderOption() {
      let xAxisDataArr = this.xAxisData;
      return {
        // 指定图表的配置项和数据
        color: ["#518FC8", "#76CBAF", "#7272CF"],
        tooltip: {trigger: "axis", axisPointer: { type: "cross"}},
        legend: {
          data: ["订单金额", "订单实付款金额", "订单数量"],
          top: "bottom",
          itemHeight: 10,
          itemGap: 30,
        },
        grid: {top: "35", left: "20", right: "20", bottom: "40", containLabel: true},
        xAxis: {data: xAxisDataArr},
        yAxis: [{type: "value", name: "金额", position: "left", axisLine: { lineStyle: { color: "black" } },
                axisLabel: { formatter: "{value}" }, splitLine: { show: false }},
                {type: "value", name: "数量", position: "right",
                axisLine: { show: true, lineStyle: { color: "black" } }, axisLabel: { formatter: "{value}" }}],
        series: [{name: "订单金额", type: "bar", barWidth: 20, barGap: 0, yAxisIndex: 0, data: this.amountChartMap},
                 {name: "订单实付款金额", type: "bar", barWidth: 20, barGap: 0, yAxisIndex: 0, data: this.payAmountChartMap},
                 {name: "订单数量", type: "bar", barWidth: 20, yAxisIndex: 1, data: this.quantityChartMap}]
      };
    },

    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    }
  },
  methods: {
    //订单统计table表格接口调用
    orederReportTable() {
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_PAGE_REPORT_ORDER_LIST,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.dataTable = result.data;
        this.totalNumber = result.totalNumber;
      });
    },

    //订单统计chat接口调用
    orederReportChat() {
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_REPORT_ORDER_CHART,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.xAxisData = Object.keys(result.data.amountChartMap);
        this.amountChartMap = Object.values(result.data.amountChartMap);
        this.quantityChartMap = Object.values(result.data.quantityChartMap);
        this.payAmountChartMap = Object.values(result.data.payAmountChartMap);
        this.totalAmount = this.formattedAmount(result.data.totalAmount) + "元";
        this.totalQuantity = result.data.totalQuantity;
        this.payAmount = this.formattedAmount(result.data.payAmount) + "元";
        this.startDate = result.data.startDate
            ? this.dateUtil.dateFormat(result.data.startDate) : "";
        this.endDate = result.data.startDate ? this.dateUtil.dateFormat(result.data.endDate) : "";
        this.drawChart();
      });
    },

    getOrderListFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_ORDER_REPORT_FILTER_DO).then((result) => {
          if (result == null) {
            return;
          }
          this.institutionList = result.data.institutionList;
          this.srcInstitutionList = result.data.institutionList;
          this.hospitalList = result.data.hospitalList;
          this.srcHospitalList = result.data.hospitalList;
          this.orderStatusList = this.commonUtil.map2List(result.data.orderStatusMap);
          this.payWayTypeList = this.commonUtil.map2List(result.data.payWayTypeMap);
          this.email = result.data.email || '';
          if (this.globalData.adminType == 2) {
            this.$set(this.filterParams, 'institutionId', this.institutionList[0].id);
          }
          resolve();
        })
      });
    },

    getDepList() {
				if (!this.filterParams.hospitalId || this.filterParams.hospitalId == -1) {
					this.deptList = [];
					this.deptDisabled = true;
					return
				}
        let params= {hspId: this.filterParams.hospitalId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_DEPARTMENT_TREE_DO,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
     	  this.vueRequest(requestData).then(result => {
					if (result == null) {
						return
					}

         this.deptList = result.data.childList;
				 this.deptDisabled = false;
       	});
			},

    //总金额排序
    sortMethod(a, b) {
      return a.totalAmountYuan * 1 > b.totalAmountYuan * 1 ? -1 : 1;
    },

    //搜索点击
    queryData() {
      this.filterParams.page = 1;
      this.filterParams.begDate = this.orderDateRange ? this.dateUtil.dateTimeFormat(this.orderDateRange[0]) : null;
      this.filterParams.endDate = this.orderDateRange ? this.dateUtil.dateTimeFormat(this.orderDateRange[1]): null;
      this.filterParams.sharingBegDate = this.completeSharingDateRange ? this.dateUtil.dateTimeFormat(this.completeSharingDateRange[0]) : null;
      this.filterParams.sharingEndDate = this.completeSharingDateRange ? this.dateUtil.dateTimeFormat(this.completeSharingDateRange[1]): null;
      if (this.deptFilterList.length) {
        this.filterParams.department1Id = this.deptFilterList[0] ? this.deptFilterList[0] : "";
        this.filterParams.department2Id = this.deptFilterList[1] ? this.deptFilterList[1] : "";
      } else {
        this.filterParams.department1Id = "";
        this.filterParams.department2Id = "";
      }
      this.orederReportTable();
      this.orederReportChat();
    },

    copyText(tetxContent) {
      this.commonUtil.copyTextToBoard(this, tetxContent);
    },

    formattedAmount(amount) {
      return Util.formattedAmount(amount);
    },

    //查看订单详情
    handleDetailClick(item) {
      this.orderId = item.id;
      this.showOrderDialog = true;
    },

    //查看评估详情
    handleSeeCollectDetails() {
      this.showCollectMoneyDialog = true;
    },

    closeOrderDialog() {
      this.showOrderDialog = false;
    },

    //关闭评估收款详情对话框
    closeDialog() {
      this.showCollectMoneyDialog = false;
    },

    //订单数据表格导出
    async handleExportOrderListExcel() {
      if (Number(this.totalQuantity) > 20000) {
        await this.$confirm('单次导出已超过20000条，请重新选择数据。', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        });
        return;
      }
      if (this.deptFilterList.length) {
        this.filterParams.department1Id = this.deptFilterList[0] ? this.deptFilterList[0] : "";
        this.filterParams.department2Id = this.deptFilterList[1] ? this.deptFilterList[1] : "";
      } else {
        this.filterParams.department1Id = "";
        this.filterParams.department2Id = "";
      }
      let param = {
        begDate: this.orderDateRange ? this.dateUtil.dateTimeFormat(this.orderDateRange[0]) : null,
        endDate: this.orderDateRange ? this.dateUtil.dateTimeFormat(this.orderDateRange[1]) : null,
        sharingBegDate: this.completeSharingDateRange ? this.dateUtil.dateTimeFormat(this.completeSharingDateRange[0]) : null,
        sharingEndDate: this.completeSharingDateRange ? this.dateUtil.dateTimeFormat(this.completeSharingDateRange[1]): null,
        institutionId: this.filterParams.institutionId,
        hospitalId: this.filterParams.hospitalId,
        serviceNameTeleno: this.filterParams.serviceNameTeleno,
        status: this.filterParams.status,
        payWay: this.filterParams.payWay,
        department1Id: this.filterParams.department1Id,
        department2Id: this.filterParams.department2Id,
      };
      let sharingDiffDay = this.dateUtil.calcDifference(param.sharingBegDate, param.sharingEndDate, 'day');
      if (sharingDiffDay && sharingDiffDay > 365) {
        this.$message({message: '完成分账时间最多可导出1年数据！', type: 'error'});
        return;
      }
      this.exportParam = param;
      this.showExportEmailTipDialog = true;
    },

    closeExportEmailTipDialog(refresh) {
      this.showExportEmailTipDialog = false;
      if (refresh) {
        this.getOrderListFilterDo();
      }
    },

    //切换选择服务机构
    handelChangeInst(val){
      this.filterParams.hospitalId = null;
      this.queryHspListFromInstId(val);
    },

    //根据服务机构Id查询对应机构下的医院列表
    async queryHspListFromInstId(instId) {
      let data = await Util.queryHspListFromInstId(instId, this);
      this.hospitalList = data.hospitalList;
      this.srcHospitalList = data.hospitalList;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.orederReportTable();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.orederReportTable();
    },
    //  订单统计分析图表
    drawChart() {
      let myChart = this.echarts.init(document.getElementById("concurrents-area"));
      myChart.setOption(this.buildOrderOption);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'ORDER'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    async initView() {
      await this.getDataPvg4CurRole();
      await this.getOrderListFilterDo();
      this.orederReportChat();
      this.orederReportTable();
    }
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "统计分析", text2: "订单统计" });
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}

.search-title {
  display: inline-block;
  color: #657180;
  font-size: 14px;
  text-align: right;
}

.report-echat {
  height: 280px;
  margin: 0 40px;
  border: 1px solid #ccc;
}

.overflow-text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.replace-order {
  padding: 0 2px;
  height: 18px;
  line-height: 17px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #0FBB9A;
  font-size: 12px;
  color: #0FBB9A;
  cursor: pointer;
}

.repeat-order {
  padding: 0 2px;
  height: 18px;
  line-height: 17px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #FF4D18;
  font-size: 12px;
  color: #FF4D18;
  margin: 0 4px;
}
</style>

<style>
.el-icon-export-excel {
  background: url("../../assets/report/icon-report-export-excel.png") no-repeat;
  font-size: 16px;
  background-size: cover;
  width: 12px;
  height: 11.52px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/OrderReport.vue